import { withNamespaces } from "react-i18next";
import { Col, Row } from "reactstrap";
import { INTERNATIONAL_MOMENT_DATE_FORMAT } from "src/components/constants";
import AIFieldLabel from "src/modules/3rd-party-management/components/AIFieldLabel";
import {
    CompanySizes
} from "src/modules/3rd-party-management/constants";
import DateUtils from "src/services/utils/DateUtils";
import { CarrierCategories } from "../../../../../constants";

const GeneralInfos = ({ t, supplierInfos, parentThirdParty }) => {
    const dateUtils = new DateUtils();

    const isDataGeneratedByAI = (fieldName) => {
        return supplierInfos.aiFieldStatus[fieldName] || false;
    }

    const getCarrierCategoryLabel = () => {
        const category = CarrierCategories.find((item) => item.value === supplierInfos.subType);

        return t(category?.label || supplierInfos.subType || '-');
    }

    const individualTypeBody = () => {
        return (
            <Row>
                <Col sm="12" md="12" lg="12" className="mb-2">
                    <AIFieldLabel
                        id="tp-category"
                        label={`${t('Category')}:`}
                        aiGenerated={isDataGeneratedByAI('type')}
                    />

                    <p>
                        {getCarrierCategoryLabel()}
                    </p>
                </Col>
                
                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-name"
                        label={t('Name') + ':'}
                        aiGenerated={isDataGeneratedByAI('name')}
                    />

                    <p>
                        {supplierInfos.name}
                    </p>
                </Col>

                {!supplierInfos.isOwnCompany && (
                    <Col sm="12" md="6" lg="3" className="mb-2">
                        <AIFieldLabel
                            id="tp-parent"
                            label={`${t('Parent')}:`}
                            aiGenerated={false}
                        />
                        <p>
                            {parentThirdParty?.label || '-'}
                        </p>
                    </Col>
                )}

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-shortname"
                        label={t('Nickname / AKA') + ':'}
                        aiGenerated={isDataGeneratedByAI('shortName')}
                    />

                    <p>
                        {supplierInfos.shortName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-localFullName"
                        label={t('Name in Local Language') + ':'}
                        aiGenerated={isDataGeneratedByAI('localLanguageFullName')}
                    />

                    <p>
                        {supplierInfos.localLanguageFullName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-localLanguageShortName"
                        label={t('Nickname / AKA in Local Language') + ':'}
                        aiGenerated={isDataGeneratedByAI('localLanguageShortName')}
                    />

                    <p>
                        {supplierInfos.localLanguageShortName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-individualDateOfBirth"
                        label={`${t('Date of Birth')}:`}
                        aiGenerated={isDataGeneratedByAI('individualDateOfBirth')}
                    />
                    <p>
                        {supplierInfos.individualDateOfBirth ? 
                            dateUtils.convertDateToDate(supplierInfos.individualDateOfBirth, INTERNATIONAL_MOMENT_DATE_FORMAT) : 
                            null}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-individualBirthPlaceCountry"
                        label={`${t('Country of Birth')}:`}
                        aiGenerated={isDataGeneratedByAI('individualBirthPlaceCountry')}
                    />
                    <p>
                        {t(supplierInfos.individualBirthPlaceCountry?.name)}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-individualTaxId"
                        label={`${t('Tax ID')}:`}
                        aiGenerated={isDataGeneratedByAI('individualTaxId')}
                    />

                    <p>
                        {supplierInfos.individualTaxId}
                    </p>
                </Col>


                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-individualNationalIdNumber"
                        label={`${t('National ID Number')}:`}
                        aiGenerated={isDataGeneratedByAI('individualNationalIdNumber')}
                    />

                    <p>
                        {supplierInfos.individualNationalIdNumber}
                    </p>
                </Col>

                <Col sm="12">
                    <AIFieldLabel
                        id="tp-description"
                        label={`${t('Description')}:`}
                        aiGenerated={isDataGeneratedByAI('description')}
                    />

                    <div dangerouslySetInnerHTML={{ __html: supplierInfos.description }} />
                </Col>
            </Row>
        )
    }

    const companyTypeBody = () => {
        return (
            <Row>
                {!supplierInfos.isOwnCompany ? (
                    <Col sm="12" md="12" lg="12" className="mb-2">
                        <AIFieldLabel
                            id="tp-category"
                            label={`${t('Category')}:`}
                            aiGenerated={isDataGeneratedByAI('type')}
                        />

                        <p>
                            {getCarrierCategoryLabel()}
                        </p>
                    </Col>
                ) : null}

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-name"
                        label={t('Name') + ':'}
                        aiGenerated={isDataGeneratedByAI('name')}
                    />

                    <p>
                        {supplierInfos.name}
                    </p>
                </Col>

                {!supplierInfos.isOwnCompany && (
                    <Col sm="12" md="6" lg="3" className="mb-2">
                        <AIFieldLabel
                            id="tp-parent"
                            label={`${t('Parent')}:`}
                            aiGenerated={false}
                        />
                        <p>
                            {parentThirdParty?.label || '-'}
                        </p>
                    </Col>
                )}

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-shortname"
                        label={t('Short Name') + ':'}
                        aiGenerated={isDataGeneratedByAI('shortName')}
                    />

                    <p>
                        {supplierInfos.shortName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-localFullName"
                        label={t('Name in Local Language') + ':'}
                        aiGenerated={isDataGeneratedByAI('localLanguageFullName')}
                    />

                    <p>
                        {supplierInfos.localLanguageFullName}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-localLanguageShortName"
                        label={t('Short Name in Local Language') + ':'}
                        aiGenerated={isDataGeneratedByAI('localLanguageShortName')}
                    />

                    <p>
                        {supplierInfos.localLanguageShortName}
                    </p>
                </Col>

                {supplierInfos.isOwnCompany && supplierInfos.legalEntities.parentLegal && (
                    <Col sm="12" md="6" lg="3" className="mb-2">
                        <AIFieldLabel
                            id="tp-legalEntities"
                            label={`${t('Parent Entity')}:`}
                            aiGenerated={isDataGeneratedByAI('legalEntities')}
                        />

                        <p>
                            {`${supplierInfos.legalEntities.parentLegal.title} ${supplierInfos.legalEntities.parentLegal.shortName ? '(' + supplierInfos.legalEntities.parentLegal.shortName + ')' : ''}`}
                        </p>
                    </Col>
                )}

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-vatNumber"
                        label={`${t('VAT ID')}:`}
                        aiGenerated={isDataGeneratedByAI('vatNumber')}
                    />

                    <p>
                        {supplierInfos.vatNumber}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-brands"
                        label={`${t('Brands')}:`}
                        aiGenerated={isDataGeneratedByAI('brands')}
                    />

                    <p>
                        {supplierInfos.brands}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-industries"
                        label={`${t('Industries')}:`}
                        aiGenerated={isDataGeneratedByAI('industries')}
                    />
                    <p>
                        <div style={{ whiteSpace: 'pre-line' }}>
                            {
                                (supplierInfos.industries || [])
                                    .map((industry) => industry?.label)
                                    .join('\n')
                            }
                        </div>
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-employeeSize"
                        label={`${t('Employee Size')}:`}
                        aiGenerated={isDataGeneratedByAI('employeeSize')}
                    />

                    <p>
                        {CompanySizes[supplierInfos.employeeSize] ? (
                            <>
                                {`${CompanySizes[supplierInfos.employeeSize]?.title} ${t("Employees")}`}
                            </>
                        ) : null}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-registrationNumber"
                        label={`${t('Registration Number')}:`}
                        aiGenerated={isDataGeneratedByAI('registrationNumber')}
                    />

                    <p>
                        {supplierInfos.registrationNumber}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-dunsNumber"
                        label={`${t('DUNS Number')}:`}
                        aiGenerated={isDataGeneratedByAI('dunsNumber')}
                    />
                    <p>
                        {supplierInfos.dunsNumber}
                    </p>
                </Col>

                <Col sm="12" md="6" lg="3" className="mb-2">
                    <AIFieldLabel
                        id="tp-websiteUrl"
                        label={`${t('Website')}:`}
                        aiGenerated={isDataGeneratedByAI('websiteUrl')}
                    />
                    <p>
                        {supplierInfos.websiteUrl}
                    </p>
                </Col>

                <Col sm="12">
                    <AIFieldLabel
                        id="tp-description"
                        label={`${t('Description')}:`}
                        aiGenerated={isDataGeneratedByAI('description')}
                    />

                    <div dangerouslySetInnerHTML={{ __html: supplierInfos.description }} />
                </Col>
            </Row>
        )
    }

    if (supplierInfos.type === 'individual') {
        return individualTypeBody()
    }

    return companyTypeBody();
}

export default withNamespaces()(
    GeneralInfos
);